import React, { Component } from 'react';
import style from './introWithWatermark.module.scss';

class IntroWithWaterMark extends Component {
  render() {
    const {
      watermark,
      title,
      label,
      registerTitle,
      registerWatermark,
    } = this.props;
    return (
      <div className={style.intro}>
        <div className={style.introInner}>
          {label && (
            <div className={style.label}>
              <div className="maskDownLabel">{label}</div>
            </div>
          )}
          <div className={style.title}>
            <h1
              ref={registerTitle ? registerTitle : ''}
              className="maskDownTitle"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>
        </div>
        {watermark && (
          <div
            ref={registerWatermark ? registerWatermark : ''}
            className={`fadeOut chapter-watermark ${style.watermark}`}
          >
            {watermark}
          </div>
        )}
      </div>
    );
  }
}

export default IntroWithWaterMark;



// WEBPACK FOOTER //
// ./src/components/global/IntroWithWatermark.js